import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { truncate } from '../../../utils/text-utils';
import { useLanguage } from '../../../context';
import { getLocalizedPath } from '../../../helpers/routes';
import { getStrapiImageUrl } from '../../../utils/image-utils';
import SkeletonImage from '../../common/SkeletonImage';

const ProductGrid = ({ domain, products, category, showAll = false, title, onItemClick }) => {
  const location = useLocation();
  const intl = useIntl();
  const { language } = useLanguage();

  const containerClassName = showAll ? "w-full" : "w-3/4 pl-8";

  const renderHeader = (text) => (
    <div className="flex items-center gap-3 mb-6">
      <span className="w-8 h-px bg-[#16A34A]" />
      <h3 className="text-sm font-semibold uppercase tracking-wide text-[#0a1628]">{text}</h3>
    </div>
  );

  const renderCard = (item, idx) => {
    const fallbackUrl = getLocalizedPath(
      `/info/${category?.slugFr || category?.slug}/${item.slug}`,
      language
    );
    const productUrl = item?.link || fallbackUrl;
    const isActive = location.pathname === productUrl;

    return (
      <NavLink
        key={item.documentId || idx}
        to={productUrl}
        onClick={onItemClick}
        className={`block border border-slate-200 transition-all duration-200 h-full flex flex-col ${
          isActive
            ? 'border-[#16A34A] bg-[#16A34A]/5'
            : 'hover:border-[#16A34A]/40 hover:shadow-sm'
        }`}
      >
        {item.metaImage && (
          <div className="shrink-0 overflow-hidden">
            <SkeletonImage
              src={getStrapiImageUrl(item.metaImage)}
              alt={item.title}
              className="w-full h-32"
              imgClassName="w-full h-full object-cover"
            />
          </div>
        )}
        <div className="p-4 flex flex-col flex-grow transition-all duration-200">
          <div className={`font-semibold ${isActive ? 'text-[#15803D]' : 'text-[#0a1628]'}`}>{item.title}</div>
          {item.metaDescription && (
            <div className={`text-sm ${isActive ? 'text-[#16A34A]' : 'text-slate-500'} mt-2`}>{truncate(item.metaDescription, 50)}</div>
          )}
        </div>
      </NavLink>
    );
  };

  return (
    <div className={containerClassName}>
      {showAll ? (
        <>
          {title && renderHeader(title)}
          <div className="grid grid-cols-3 gap-6">
            {products.map((item, idx) => renderCard(item, idx))}
          </div>
        </>
      ) : domain ? (
        <>
          {renderHeader(domain)}
          <div className="grid grid-cols-3 gap-6">
            {products.map((item, idx) => renderCard(item, idx))}
          </div>
        </>
      ) : (
        <div className="text-center py-12 text-slate-500">
          {intl.formatMessage({ id: "menu.selectDomain" })}
        </div>
      )}
    </div>
  );
};

export default ProductGrid;